import { Sidebar } from "primereact/sidebar";
import { getIcons } from "../../../Constant/Constant";
import {
  balconyDirection,
  balconyView,
  coveredParkingType,
  liftType,
  parkingType,
  plotStatusIds,
  roadFacingSides,
  swimmingPoolType,
  villaViewType,
} from "../../../../Enum";
import AsteriskStyle from "../../../Form/Tooltip/AsteriskStyle";
import { useState } from "react";
import ConfirmationModal from "../../../shareableContainer/ConfirmationModal";

const ApartmentUnitForm = ({
  unit = {},
  isSliderOpen,
  onHide,
  handleChange,
  handleSave,
  handleCancel,
  handleFloorsChange,
  handleUnitFormChange,
  handleFloorBhkChange,
  handleApplyToAll,
  
  isNew = false,
}) => {
  const icons = getIcons();

    const [isModel, setIsModel] = useState(false);
    const [pendingStatusId, setPendingStatusId] = useState(null);
  
    const handelConfirmStatus = () => {
      handleChange({
        target: { name: "unitStatus", value: pendingStatusId },
      });
      setIsModel(false);
    };

  //console.log(unit);

 // console.log("unit.floorsBhk", unit.floorsBhk);

  const floorsBhk =
    unit.floorsBhk ||
    Array(unit.floors || 0)
      .fill()
      .map((_, i) => ({
        floor: i + 1,
        bhk: 0,
      }));

  return (
    <>
    {!isModel && (
       <Sidebar
       header={
         <div className="flex items-center justify-between w-full">
           <span className="font-semibold text-lg text-customGreen">
             {isNew ? "Add" : "Edit"} Apartment Unit
           </span>
         </div>
       }
       visible={isSliderOpen}
       onHide={onHide}
       style={{ width: "560px" }}
       position="right"
       className="p-sidebar-md"
     >
       
       <div className="flex flex-col gap-5 p-4">
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Unit Number <AsteriskStyle/>
           </label>
           <div className="col-span-8">
             <input
               type="text"
               name="unitNo"
               value={unit.unitNo || ""}
               onChange={handleChange}
               maxLength={5}
               className="w-full px-3 py-2 border uppercase border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="e.g., A101"
             />
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Saleable Area <AsteriskStyle/>
           </label>
           <div className="col-span-8 relative w-full">
             <input
               type="number"
               name="saleableArea"
               maxLength={10}
               value={unit.saleableArea || ""}
               onChange={(e) => {
                const value = e.target.value;
              
                const regex = /^\d{0,7}(\.\d{0,2})?$/;
              
                if (value === "" || (regex.test(value) && Number(value) >= 0)) {
                  handleChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="Saleable Area Square Feet"
             />
             <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md p-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
               SQ.FT
             </span>
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Build-Up Area <AsteriskStyle/>
           </label>
           <div className="col-span-8 relative w-full">
             <input
               type="number"
               name="buildUpArea"
               value={unit.buildUpArea || ""}
               onChange={(e) => {
                const value = e.target.value;
              
                const regex = /^\d{0,7}(\.\d{0,2})?$/;
              
                if (value === "" || (regex.test(value) && Number(value) >= 0)) {
                  handleChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="Build-Up Area Square Feet"
             />
             <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md p-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
               SQ.FT
             </span>
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
           Unit Floors <AsteriskStyle/>
           </label>
           <div className="col-span-8 relative">
             <select
               name="floors"
               value={unit.floors || 0}
               onChange={handleFloorsChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none"
             >
               {Array.from({ length: 6 }, (_, i) => (
                 <option key={i} value={i}>
                   {i}
                 </option>
               ))}
             </select>
             <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
               <svg
                 className="w-4 h-4 text-gray-400"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth="2"
                   d="M19 9l-7 7-7-7"
                 ></path>
               </svg>
             </div>
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Total BHK <AsteriskStyle/>
           </label>
           <div className="col-span-8">
             <select
               name="totalBhk"
               value={unit.totalBhk}
               onChange={handleChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
             >
               <option value="" disabled>
                 Select BHK
               </option>
               {Array.from({ length: 16 }, (_, i) => i ).map((num) => (
                 <option key={num} value={num}>
                   {num}
                 </option>
               ))}
             </select>
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Base Rate <AsteriskStyle/>
           </label>
           <div className="col-span-8 relative w-full">
             <input
               type="number"
               name="baseRate"
               value={unit.baseRate || ""}
               onChange={(e) => {
                const value = e.target.value;
              
                const regex = /^\d{0,10}(\.\d{0,2})?$/;
              
                if (value === "" || (regex.test(value) && Number(value) >= 0)) {
                  handleChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               className="w-full px-3 py-2  border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="Base Rate "
             />
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Base Price <AsteriskStyle/>
           </label>
           <div className="col-span-8 relative w-full">
             <input
               type="number"
               name="basePrice"
               value={
                 unit.saleableArea && unit.baseRate
                   ? (
                       parseFloat(unit.saleableArea) * parseFloat(unit.baseRate)
                     ).toFixed(2)
                   : 0
               }

               readOnly
               className="w-full px-3 py-2 pr-16 border bg-gray-100 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="Base Price"
             />
           </div>
         </div>
 
         {/* {floorsBhk.map((item, index) => (
           <div className="grid grid-cols-12 items-center mb-2" key={index}>
             <label className="col-span-4 text-sm font-medium text-gray-700">
               {index === 0 ? "1st Floor BHK" : `${index + 1}nd Floor BHK`}
             </label>
             <div className="col-span-8 relative">
               <select
                 value={item.bhk || 0}
                 onChange={(e) => handleFloorBhkChange(index, e.target.value)}
                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none"
               >
                 {Array.from({ length: 6 }, (_, i) => (
                   <option key={i} value={i}>
                     {i}
                   </option>
                 ))}
               </select>
               <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                 <svg
                   className="w-4 h-4 text-gray-400"
                   fill="none"
                   stroke="currentColor"
                   viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth="2"
                     d="M19 9l-7 7-7-7"
                   ></path>
                 </svg>
               </div>
             </div>
           </div>
         ))} */}
 
 
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Status <AsteriskStyle/>
           </label>
           <div className="col-span-8 relative">
             <select
               name="unitStatus"
               value={unit?.unitStatus?.id}
               onChange={(e) => {
                 setPendingStatusId(e.target.value);
                 setIsModel(true);
               }}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none bg-gray-50"
             >
               {plotStatusIds.map((status) => (
                 <option key={status.value} value={status.id}>
                   {status.label}
                 </option>
               ))}
             </select>
             <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
               <svg
                 className="w-4 h-4 text-gray-400"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth="2"
                   d="M19 9l-7 7-7-7"
                 ></path>
               </svg>
             </div>
           </div>
         </div>
 
         {/* <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Road Facing Side <AsteriskStyle/>
           </label>
           <div className="col-span-8 relative">
             <select
               name="roadFacingSide"
               value={unit.roadFacingSide?.id || ""}
               onChange={handleUnitFormChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none"
             >
               <option value="" disabled>
                 Select Side
               </option>
               {roadFacingSides.map((side) => (
                 <option key={side.id} value={side.id}>
                   {side.label}
                 </option>
               ))}
             </select>
 
             <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
               <svg
                 className="w-4 h-4 text-gray-400"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth="2"
                   d="M19 9l-7 7-7-7"
                 ></path>
               </svg>
             </div>
           </div>
         </div> */}
 
         <label className="text-sm font-medium text-green-600">
           Other Charges
         </label>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Guideline Sq.Ft Price
           </label>
           <div className="col-span-8">
             <input
               type="number"
               name="guidelineSqftPrice"
               value={unit.guidelineSqftPrice || ""}
               onChange={(e) => {
                 const value = e.target.value;
                 if (/^\d{0,10}$/.test(value) && value >= 0) {
                   handleChange(e);
                 }
               }}
               onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="Price per Sq.Ft"
             />
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Registration Charge
           </label>
           <div className="col-span-8">
             <input
               type="number"
               name="registrationCharge"
               value={unit.registrationCharge || ""}
               onChange={(e) => {
                 const value = e.target.value;
                 if (/^\d{0,10}$/.test(value) && value >= 0) {
                   handleChange(e);
                 }
               }}
               onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               className="w-full px-3 py-2 border  border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="Registration Charge"
             />
           </div>
         </div>
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             All Inclusive Charges
           </label>
           <div className="col-span-8">
             <input
               type="number"
               name="allInclusiveCharges"
               value={unit.allInclusiveCharges || ""}
               onChange={(e) => {
                 const value = e.target.value;
                 if (/^\d{0,10}$/.test(value) && value >= 0) {
                   handleChange(e);
                 }
               }}
               onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               className="w-full px-3 py-2 border  border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="All InclusiveCharges "
             />
           </div>
         </div>
 
         <div className="flex flex-col gap-3">
           <label className="text-sm font-medium text-green-600">
             Furnished
           </label>
           <div className="col-span-8 flex gap-4">
             {[
               {
                 value: "Furnished",
                 label: "Furnished",
                 icon: icons?.villaFurnished,
               },
               {
                 value: "Semi Furnished",
                 label: "Semi Furnished",
                 icon: icons?.villaSemiFurnished,
               },
               {
                 value: "Unfurnished",
                 label: "Unfurnished",
                 icon: icons?.villaNonFurnished,
               },
             ].map((option) => (
               <label
                 key={option.value}
                 className="flex flex-col items-center cursor-pointer"
               >
                 <img
                   src={option.icon}
                   alt={option.label}
                   className={`w-28 h-28 p-1 rounded-lg border-2 ${
                     unit.furnished === option.value
                       ? "shadow-lg"
                       : "bg-slate-100 border-transparent"
                   }`}
                 />
                 <input
                   type="radio"
                   name="furnished"
                   value={option.value}
                   checked={unit.furnished === option.value}
                   onChange={handleChange}
                   className="hidden"
                 />
                 <span
                   className={`text-xs mt-2 ${
                     unit.furnished === option.value ? "text-customGreen" : ""
                   }`}
                 >
                   {option.label}
                 </span>
               </label>
             ))}
           </div>
         </div>
 
         <button className="text-sm font-medium text-green-600 flex items-center">
         Balcony Details
           <svg
             className="w-4 h-4 ml-1"
             fill="none"
             stroke="currentColor"
             viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg"
           >
             <path
               strokeLinecap="round"
               strokeLinejoin="round"
               strokeWidth="2"
               d="M19 9l-7 7-7-7"
             ></path>
           </svg>
         </button>
         
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
           Balcony Direction
           </label>
           <div className="col-span-8 relative">
             <select
               name="lift"
               value={unit.lift || ""}
               onChange={handleChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none"
             >
               <option value="" disabled>
                 Select Balcony Direction
               </option>
               {balconyDirection.map((type) => (
                 <option key={type.value} value={type.value}>
                   {type.label}
                 </option>
               ))}
             </select>
 
             <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
               <svg
                 className="w-4 h-4 text-gray-400"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth="2"
                   d="M19 9l-7 7-7-7"
                 ></path>
               </svg>
             </div>
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
           Balcony View
           </label>
           <div className="col-span-8 relative">
             <select
               name="swimmingPool"
               value={unit.swimmingPool || ""}
               onChange={handleChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none"
             >
               <option value="" disabled>
                 Select Balcony View 
               </option>
               {balconyView.map((type) => (
                 <option key={type.value} value={type.value}>
                   {type.label}
                 </option>
               ))}
             </select>
 
             <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
               <svg
                 className="w-4 h-4 text-gray-400"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth="2"
                   d="M19 9l-7 7-7-7"
                 ></path>
               </svg>
             </div>
           </div>
         </div>
 
         <button className="text-sm font-medium text-green-600 flex items-center">
           More Details
           <svg
             className="w-4 h-4 ml-1"
             fill="none"
             stroke="currentColor"
             viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg"
           >
             <path
               strokeLinecap="round"
               strokeLinejoin="round"
               strokeWidth="2"
               d="M19 9l-7 7-7-7"
             ></path>
           </svg>
         </button>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Carpet Area
           </label>
           <div className="col-span-8 relative w-full">
             <input
               type="number"
               name="carpetArea"
               value={unit.carpetArea || ""}
               onChange={(e) => {
                const value = e.target.value;
              
                const regex = /^\d{0,10}(\.\d{0,2})?$/;
              
                if (value === "" || (regex.test(value) && Number(value) >= 0)) {
                  handleChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
               placeholder="Carpet Area"
             />
             <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md p-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
               SQ.FT
             </span>
           </div>
         </div>
 
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Bathrooms
           </label>
           <div className="col-span-8 relative">
             <select
               name="bathrooms"
               value={unit.bathrooms || ""}
               onChange={handleChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none"
             >
               <option value="" disabled>
                 Select Bathrooms
               </option>
               {["1", "2", "3", "4", "5", "6", "7"].map((num) => (
                 <option key={num} value={num}>
                   {num}
                 </option>
               ))}
             </select>
             <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
               <svg
                 className="w-4 h-4 text-gray-400"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth="2"
                   d="M19 9l-7 7-7-7"
                 ></path>
               </svg>
             </div>
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Parking
           </label>
           <div className="col-span-8 relative">
             <select
               name="parking"
               value={unit.parking || ""}
               onChange={handleChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none"
             >
               <option value="" disabled>
                 Select Parking Type
               </option>
               {parkingType.map((type) => (
                 <option key={type.id} value={type.value}>
                   {type.label}
                 </option>
               ))}
             </select>
             <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
               <svg
                 className="w-4 h-4 text-gray-400"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth="2"
                   d="M19 9l-7 7-7-7"
                 ></path>
               </svg>
             </div>
           </div>
         </div>
 
         <div className="grid grid-cols-12 items-center">
           <label className="col-span-4 text-sm font-medium text-gray-700">
             Covered Parking
           </label>
           <div className="col-span-8 relative">
             <select
               name="coveredParking"
               value={unit.coveredParking || ""}
               onChange={handleChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none"
             >
               <option value="" disabled>
                 Select Covered Parking Type
               </option>
               {coveredParkingType.map((type) => (
                 <option key={type.value} value={type.value}>
                   {type.label}
                 </option>
               ))}
             </select>
 
             <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
               <svg
                 className="w-4 h-4 text-gray-400"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth="2"
                   d="M19 9l-7 7-7-7"
                 ></path>
               </svg>
             </div>
           </div>
         </div>
 
         <button className="text-[16px] font-medium text-green-600 flex items-center">
           Notes
           <svg
             className="w-4 h-4 ml-1"
             fill="none"
             stroke="currentColor"
             viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg"
           >
             <path
               strokeLinecap="round"
               strokeLinejoin="round"
               strokeWidth="2"
               d="M19 9l-7 7-7-7"
             ></path>
           </svg>
         </button>
 
         <div className=" items-center">
           <div className="col-span-8">
             <input
               type="text"
               name="notes"
               maxLength={250}
               value={unit.notes || ""}
               onChange={handleChange}
               className="w-full px-3 py-2 border border-gray-300 rounded-md  focus:outline-none"
             />
           </div>
         </div>
 
    
 
 
 
 
         <div className="flex gap-4 mt-6">
           <button
             onClick={handleSave}
             className="w-full py-3 bg-customGreen text-white rounded-md hover:bg-green-600 focus:outline-none font-medium"
           >
             Done
           </button>
         </div>
       </div>
     </Sidebar>
    )}
   
     <ConfirmationModal
     showModal={isModel}
     title="Change Unit Status"
     message="Are you sure you want to change the unit status?"
     onConfirm={handelConfirmStatus}
     onCancel={() => {
       setIsModel(false);
       setPendingStatusId(null);
     }}
   />
 </>
  );
};

export default ApartmentUnitForm;
